import { Link } from 'react-router-dom'
import { ModalShell } from '../../admin/modals/ModalShell'
import type { ProcurementAlert } from '../types'

const LEVEL_LABEL: Record<ProcurementAlert['level'], string> = {
  critical: '🔴 Критично',
  warning: '🟡 Внимание',
  info: '🔵 Инфо',
}

export function ReminderModal({
  alert,
  onClose,
}: {
  alert: ProcurementAlert
  onClose: () => void
}) {
  return (
    <ModalShell
      title={alert.message}
      subtitle={LEVEL_LABEL[alert.level]}
      onClose={onClose}
      size="sm"
    >
      <div className="space-y-4">
        {alert.description && <p className="text-sm text-gray-700">{alert.description}</p>}

        <div className="rounded-lg bg-gray-50 p-3 text-xs text-gray-500">
          {alert.level === 'critical' &&
            'Рекомендуем связаться с поставщиком или попросить альтернативный источник у админа.'}
          {alert.level === 'warning' &&
            'Обсудите с админом перераспределение позиций или отложите часть в очереди.'}
          {alert.level === 'info' &&
            'Проинформируйте менеджеров — цена может повлиять на сборку КП.'}
        </div>

        <div className="flex justify-end gap-2">
          {alert.actionUrl ? (
            <Link
              to={alert.actionUrl}
              onClick={onClose}
              className="px-3 py-1.5 text-sm rounded-lg bg-gray-900 text-white hover:bg-gray-800"
            >
              Перейти →
            </Link>
          ) : null}
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-sm rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50"
          >
            Закрыть
          </button>
        </div>
      </div>
    </ModalShell>
  )
}
